export default __webpack_public_path__ + "static/media/bg.621923af.png";